// NOTE: NSAI-6636 / NSAI-6647 — the ONE "you are here" treatment, taken from
// the main sidebar's nav rows (`sidebarMenuButtonVariants` in `sidebar.tsx`,
// with the rail's `rounded-xl` from `NAV_BUTTON_CLASS`): the `--sidebar-accent`
// pill, its foreground at medium weight, and the thin brand bar on the leading
// edge. The chat lists (all chats, folder chats, assistant chats) and the
// settings navs render their active row with these same classes, so a tenant
// theme that brands `--sidebar-accent` brands every selected row at once. The
// chat rows used to read their own `--sidebar-chat-active-background`, which
// tenant stylesheets set to a solid brand fill — the one selected row in the
// app that looked nothing like the others. Keep this in step with
// `sidebarMenuButtonVariants`: if the nav's marker changes, this changes too.
//
// NOTE: `overflow-hidden` is what puts the bar INSIDE the pill. The bar starts
// 6px from the top and bottom, which is inside a `rounded-xl` corner's 12px
// curve, so without a clip its ends poke out past the rounded edge. The nav
// button clips (it carries `overflow-hidden` in its base variant); the chat
// and settings rows did not, and their bar read as sitting outside the row.
export const SIDEBAR_ITEM_RADIUS_CLASS = "rounded-xl" as const;

export const SIDEBAR_ITEM_ACTIVE_CLASS =
  "overflow-hidden bg-sidebar-accent font-medium text-sidebar-accent-foreground before:absolute before:inset-y-1.5 before:start-0 before:w-0.5 before:rounded-full before:bg-primary before:content-['']" as const;

export const SIDEBAR_ITEM_HOVER_CLASS =
  "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground" as const;
